import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getSexes } from "../../slices/codeBookSlice";

export const useGetSexes = () => {
  const sexes = useSelector((state: RootState) => state.codeBook.sexes);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSexes());
  }, [dispatch]);

  return sexes;
};
